export { default } from '../course-details'
